// @flow
import { connect } from 'react-redux'
import AdditionalParamsTextArea from './AdditionalParamsTextArea'
import type { Store } from '../../redux/ducks'
import { patch } from '../AudienceEditContainer'

function mapStateToProps(state: Store) {
  const audienceState = state.audienceEdit

  return {
    errors: audienceState.aboutCompanyErrors,
    value: audienceState.aboutCompany
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onChange: (value: string) => patch(dispatch, { aboutCompany: value })
  }
}

const AboutCompanyContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(AdditionalParamsTextArea)

export default AboutCompanyContainer
